import { EditorAssistance } from '../../../models/EditorAssistance'
import { EditorAssistanceBundle } from './EditorAssistanceBundle'

export class EditorAssistanceBundleBuilder {
  private main: EditorAssistance
  private children: EditorAssistance[] = []
  selectedAssistanceId: number

  setMain(editorAssistance: EditorAssistance) {
    this.main = editorAssistance
    return this
  }
  addChild(editorAssistance: EditorAssistance) {
    this.children.push(editorAssistance)
  }

  addChildren(bundleChildren: EditorAssistance[]) {
    bundleChildren.forEach((i) => this.addChild(i))
  }
  setActive(selectedAssistanceId: number) {
    this.selectedAssistanceId = selectedAssistanceId
  }
  build() {
    return new EditorAssistanceBundle(this.main, this.children, this.selectedAssistanceId)
  }
}
